<!--
@Time : 2020/11/30 6:21 上午
@Author : yekong
@File : jiankong2.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paimingk">
      <div ref="myChart6" style="width: 320px;height: 400px"></div>
      <div ref="myChart7" style="width: 228px;height: 400px"></div>
      <div ref="myChart8" style="width: 228px;height: 400px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "jiankong2",
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      // let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let myChart = this.$echarts.init(this.$refs.myChart6)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '13%',
          right: '0%',
          left: '30%',
          bottom: '19%'
        },
        title: {
          text: '平均停电时长',
          x: '120',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 25
          }
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
            formatter: function (value) {
              //x轴的文字改为竖版显示
              var str = value.split("");
              return str.join("\n");
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          name: '(分)',
          minInterval: 25,
          nameTextStyle: {
            color: "rgba(155, 173, 255, 1)",
            fontSize: 30,
            padding: [0, 0, 5, -60],
          },
          axisLabel: {
            formatter: '{value}',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 20, 20],
          barWidth: '30px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
        }
        ]
      });
    },
    drawLine2() {
      // 基于准备好的dom，初始化echarts实例
      // let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let myChart = this.$echarts.init(this.$refs.myChart7)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '13%',
          right: '0%',
          left: '0',
          bottom: '19%'
        },
        title: {
          text: '平均停电频次',
          x: '20',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 25
          }
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
            formatter: function (value) {
              //x轴的文字改为竖版显示
              var str = value.split("");
              return str.join("\n");
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 20, 20],
          barWidth: '30px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
        }
        ]
      });
    },
    drawLine3() {
      // 基于准备好的dom，初始化echarts实例
      // let myChart = this.$echarts.init(document.getElementById('myChart6'))
      let myChart = this.$echarts.init(this.$refs.myChart8)
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '13%',
          right: '0%',
          left: '0',
          bottom: '19%'
        },
        title: {
          text: '平均不停电作业率',
          x: '0',
          y: 'top',
          textStyle: {
            //文字颜色
            color: 'rgba(57, 249, 255, 1)',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'bold',
            //字体系列
            fontFamily: 'sans-serif',
            //字体大小
            fontSize: 25
          }
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 1)',
              width: 3
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 18,
              color: "rgba(255, 255, 255, 1)" //X轴文字颜色
            },
            formatter: function (value) {
              //x轴的文字改为竖版显示
              var str = value.split("");
              return str.join("\n");
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          minInterval: 25,
          axisLabel: {
            show: false,
            formatter: '{value}分',
            color: 'rgba(155, 173, 255, 1)',
            textStyle: {
              fontSize: 30
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(236, 239, 249, 1)',
              width: 1
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(156, 164, 191, 1)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 20, 20],
          barWidth: '30px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              // barBorderRadius: [15, 15, 0, 0]
            },
          },
        }
        ]
      });
    },
  },
  mounted() {
    this.drawLine();
    this.drawLine2();
    this.drawLine3();
  },
}
</script>

<style lang="scss" scoped>
.paimingk {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-top: 50px;
}

.biaodan {
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: column;
  margin-right: 45px;

  p {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9BADFF;
    line-height: 35px;
  }
}
</style>
